import React, { useState } from "react";

const LearningPathTFD = () => {
  const [toggleAllSections, setToggleAllSections] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({});
  const [toggleNewModule, setToggleNewModule] = useState(false);
  const [newModuleToggle, setNewModuleToggle] = useState({});
  const [toggleExteraModule, setToggleExteraModule] = useState(false);
  const [exteraModuleToggle, setExteraModuleToggle] = useState({});
  const [toggleIsExteraModule, setToggleIsExteraModule] = useState(false);
  const [isExteraModuleToggle, setIsExteraModuleToggle] = useState({});
  const [toggleAdditionalModule, setToggleAdditionalModule] = useState(false);
  const [additionalModuleToggle, setAdditionalModuleToggle] = useState({});
  const [toggleExtraAdvancedModule, setToggleExtraAdvancedModule] = useState(false);
  const [extraAdvancedModuleToggle, setExtraAdvancedModuleToggle] = useState({});
  const [toggleAndLocalModule, setToggleAndLocalModule]= useState(false);
  const [AndLocalModuleToggle, setAndLocalModuleToggle]= useState({});
  const [toggleAndUlteraLocalModule, setToggleAndUlteraLocalModule]= useState(false);
  const [AndUlteraLocalModuleToggle, setAndUlteraLocalModuleToggle]= useState({});
  
  const listContent = [
    // MySQL Fundamentals
    {
      id: 1,
      title: "Introduction to MySQL",
      nestedContent: [
        { id: 1, text: "• History and features of MySQL database.", dummyText: [] },
        { id: 2, text: "• Understanding relational database management systems (RDBMS).", dummyText: [] },
        { id: 3, text: "• Installing and configuring MySQL Server and Workbench.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Database Design Fundamentals",
      nestedContent: [
        { id: 1, text: "• Understanding database schema and design principles.", dummyText: [] },
        { id: 2, text: "• Entity-Relationship (ER) modeling and normalization.", dummyText: [] },
       
      ],
    },
    {
        id: 3,
        title: "SQL Basics",
        nestedContent: [
          { id: 1, text: "• Data Definition Language (DDL): CREATE, ALTER, DROP.", dummyText: [] },
          { id: 2, text: "• Data Manipulation Language (DML): INSERT, UPDATE, DELETE.", dummyText: [] },
          { id: 3, text: "• Data Query Language (DQL): SELECT statements.", dummyText: [] },
        ],
      },
      {
        id: 4,
        title: "Advanced SQL Queries",
        nestedContent: [
          { id: 1, text: "• WHERE clause and conditional filtering.", dummyText: [] },
          { id: 2, text: "• JOIN operations (INNER, LEFT, RIGHT, FULL OUTER).", dummyText: [] },
          { id: 3, text: "• Subqueries and nested queries.", dummyText: [] },
          { id: 4, text: "• Aggregate functions (COUNT, SUM, AVG, MAX, MIN).", dummyText: [] },
        ],
      },
  ];

  const newModuleContent = [
    // Spring Boot Fundamentals
    {
      id: 1,
      title: "Introduction to Spring Boot",
      nestedContent: [
        { id: 1, text: "• Overview of Spring Framework and Spring Boot.", dummyText: [] },
        { id: 2, text: "• Spring Boot architecture and core features.", dummyText: [] },
        { id: 3, text: "• Setting up Spring Boot development environment (STS, IntelliJ IDEA).", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Spring Boot Basics",
      nestedContent: [
        { id: 1, text: "• Creating first Spring Boot application.", dummyText: [] },
        { id: 2, text: "• Understanding Spring Boot starters and auto-configuration.", dummyText: [] },
        { id: 3, text: "• Application properties and YAML configuration.", dummyText: [] },
      ],
    },
    {
        id: 3,
        title: "REST API Development",
        nestedContent: [
          { id: 1, text: "• Building RESTful web services with Spring Boot.", dummyText: [] },
          { id: 2, text: "• Controllers, RequestMapping, and RequestBody annotations.", dummyText: [] },
          { id: 3, text: "• HTTP methods: GET, POST, PUT, DELETE.", dummyText: [] },
          { id: 4, text: "• Path variables, request parameters, and response entities.", dummyText: [] },
        ],
        },
    
      {
        id: 4,
        title: "Dependency Injection and IoC",
        nestedContent: [
          { id: 1, text: "• Inversion of Control (IoC) and Dependency Injection.", dummyText: [] },
          { id: 2, text: "• @Autowired, @Component, @Service, @Repository annotations.", dummyText: [] },
        ],
      },
      {
        id: 5,
        title: "Practical Exercises",
        nestedContent: [
          { id: 1, text: "• Creating a simple REST API for user management.", dummyText: [] },
          
        ],
      },
     
      
  ];

  const exteraModuleContent = [
    // MySQL & Spring Boot Integration
    {
      id: 3,
      title: "Spring Data JPA and Hibernate",
      nestedContent: [
        { id: 1, text: "• Introduction to JPA and Hibernate ORM.", dummyText: [] },
        { id: 2, text: "• Entity mapping and table relationships (One-to-One, One-to-Many, Many-to-Many).", dummyText: [] },
        { id: 3, text: "• CRUD operations using JpaRepository.", dummyText: [] },
      ],
    },
    {
      id: 4,
      title: "MySQL Integration with Spring Boot",
      nestedContent: [
        { id: 1, text: "• Configuring MySQL database connection in Spring Boot.", dummyText: [] },
        { id: 2, text: "• Using application.properties for database configuration.", dummyText: [] },
        { id: 3, text: "• Connection pooling with HikariCP.", dummyText: [] },
      ],
    },
    {
        id: 5,
        title: "Query Methods and Custom Queries",
        nestedContent: [
          { id: 1, text: "• Derived query methods in Spring Data JPA.", dummyText: [] },
          { id: 2, text: "• Using @Query annotation for custom JPQL and native SQL queries.", dummyText: [] },
        ],
      },
      {
        id: 6,
        title: "Practical Exercises",
        nestedContent: [
          { id: 1, text: "• Building a CRUD application with MySQL database integration.", dummyText: [] },
        ],
      },
  ];

  const additionalModuleContent = [
    // Advanced Spring Boot Features
    {
      id: 5,
      title: "Spring Boot Security",
      nestedContent: [
        { id: 1, text: "• Introduction to Spring Security.", dummyText: [] },
        { id: 2, text: "• Authentication and authorization mechanisms.", dummyText: [] },
        { id: 3, text: "• Role-based access control (RBAC).", dummyText: [] },
      ],
    },
    {
      id: 6,
      title: "JWT Authentication",
      nestedContent: [
        { id: 1, text: "• JSON Web Tokens (JWT) implementation.", dummyText: [] },
        { id: 2, text: "• Securing REST APIs with JWT.", dummyText: [] },
      ],
    },
    {
        id: 7,
        title: "Exception Handling and Validation",
        nestedContent: [
          { id: 1, text: "• Global exception handling with @ControllerAdvice.", dummyText: [] },
          { id: 2, text: "• Input validation using Bean Validation (Hibernate Validator).", dummyText: [] },
        ],
      },
      {
        id: 8,
        title: "Practical Exercises",
        nestedContent: [
          { id: 1, text: "• Implementing security and JWT in REST APIs.", dummyText: [] },
        ],
      },
      
      
  ];

  const isExteraModuleContent = [
    // Advanced Database Concepts
    {
      id: 7,
      title: "Stored Procedures and Functions",
      nestedContent: [
        { id: 1, text: "• Creating and calling stored procedures in MySQL.", dummyText: [] },
        { id: 2, text: "• Functions and triggers in MySQL.", dummyText: [] },
      ],
    },
    {
      id: 8,
      title: "Transactions and Concurrency",
      nestedContent: [
        { id: 1, text: "• ACID properties and transaction management.", dummyText: [] },
        { id: 2, text: "• @Transactional annotation in Spring Boot.", dummyText: [] },
        { id: 3, text: "• Isolation levels and propagation behaviors.", dummyText: [] },
      ],
    },
    {
        id: 9,
        title: "Database Indexing and Performance",
        nestedContent: [
          { id: 1, text: "• Creating and managing indexes in MySQL.", dummyText: [] },
          { id: 2, text: "• Query optimization and performance tuning.", dummyText: [] },
        ],
      },
      
      {
        id: 10,
        title: "Practical Exercises",
        nestedContent: [
          { id: 1, text: "• Implementing transactions and optimizing database queries.", dummyText: [] },
        
        ],
      },
      
  ];

  const extraAdvancedModuleContent = [
    // Microservices with Spring Boot
    {
      id: 9,
      title: "Microservices Architecture",
      nestedContent: [
        { id: 1, text: "• Introduction to microservices and Spring Cloud.", dummyText: [] },
        { id: 2, text: "• Service discovery with Eureka.", dummyText: [] },
      ],
    },
    {
      id: 10,
      title: "API Gateway and Load Balancing",
      nestedContent: [
        { id: 1, text: "• Spring Cloud Gateway for routing.", dummyText: [] },
        { id: 2, text: "• Client-side load balancing with Ribbon.", dummyText: [] },
      ],
    },
    {
      id: 11,
      title: "Inter-Service Communication",
      nestedContent: [
        { id: 1, text: "• REST communication between microservices.", dummyText: [] },
        { id: 2, text: "• Using Feign Client for declarative REST calls.", dummyText: [] },
        { id: 3, text: "• Circuit Breaker pattern with Resilience4j.", dummyText: [] },
      ],
    },
    {
        id: 12,
        title: "Practical Project",
        nestedContent: [
          { id: 1, text: "• Building a microservices-based e-commerce application.", dummyText: [] },
        ],
      },
  ];

  const andLocalModuleContent = [
    // Testing and Deployment
    {
      id: 13,
      title: "Unit Testing with JUnit and Mockito",
      nestedContent: [
        { id: 1, text: "• Writing unit tests for Spring Boot applications.", dummyText: [] },
        { id: 2, text: "• Mocking dependencies with Mockito.", dummyText: [] },
      ],
    },
    {
      id: 14,
      title: "Integration Testing",
      nestedContent: [
        { id: 1, text: "• Testing REST APIs with MockMvc.", dummyText: [] },
        { id: 2, text: "• @DataJpaTest for repository testing.", dummyText: [] },
        { id: 3, text: "• TestContainers for database testing.", dummyText: [] },
      ],
    },
    {
      id: 15,
      title: "Deployment and DevOps",
      nestedContent: [
        { id: 1, text: "• Creating executable JAR files.", dummyText: [] },
        { id: 2, text: "• Deploying Spring Boot applications to AWS, Azure, or GCP.", dummyText: [] },
        { id: 3, text: "• Using Docker containers for deployment.", dummyText: [] },
      ],
    },
    {
      id: 16,
      title: "Practical Exercises",
      nestedContent: [
        { id: 1, text: "• Testing and deploying a complete Spring Boot application.", dummyText: [] },
      ],
    },
    
  ];
  
  const andUlteraLocalModuleContent = [
    // Capstone Project
    {
      id: 16,
      title: "Project Planning and Requirements",
      nestedContent: [
        { id: 1, text: "• Understanding business requirements and use cases.", dummyText: [] },
        { id: 2, text: "• Database schema design for the project.", dummyText: [] },
      ],
    },
    {
      id: 17,
      title: "Backend Development",
      nestedContent: [
        { id: 1, text: "• Implementing REST APIs with Spring Boot.", dummyText: [] },
        { id: 2, text: "• Integrating MySQL database with JPA/Hibernate.", dummyText: [] },
        { id: 3, text: "• Implementing business logic and validation.", dummyText: [] },
      ],
    },
    {
        id: 18,
        title: "Security Implementation",
        nestedContent: [
          { id: 1, text: "• Adding Spring Security and JWT authentication.", dummyText: [] },
          { id: 2, text: "• Role-based access control implementation.", dummyText: [] },
        ],
      },
    {
      id: 19,
      title: "Testing and Quality Assurance",
      nestedContent: [
        { id: 1, text: "• Unit testing and integration testing.", dummyText: [] },
        { id: 2, text: "• API testing with Postman.", dummyText: [] },
      ],
    },
    {
        id: 20,
        title: "Documentation and Deployment",
        nestedContent: [
          { id: 1, text: "• API documentation using Swagger/OpenAPI.", dummyText: [] },
          { id: 2, text: "• Deploying the application to cloud platform.", dummyText: [] },
        ],
      },
    {
        id: 21,
        title: "Final Project Presentation",
        nestedContent: [
          { id: 1, text: "• Presenting the complete project with live demo.", dummyText: [] },
          { id: 2, text: "• Code review and feedback session.", dummyText: [] },
        ],
      },
  ];

  const toggleSection = (id, module = "existing") => {
    if (module === "existing") {
      setSectionToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "new") {
      setNewModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extera") {
      setExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "isextera") {
      setIsExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "additional") {
      setAdditionalModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extraAdvanced") {
      setExtraAdvancedModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    }else if (module === "andLocal"){
        setAndLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
   } else if (module === "andUlteraLocal"){
    setAndUlteraLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
  }
  };
  
  return (
    <div className="container my-5">
      <h2 className="fw-bold mb-4" style={{ color: "#000", fontFamily: "Roboto", textAlign: "center",marginTop:'-37px', }}>
        PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
      </h2>
      <br />
      
      {/* MySQL Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAllSections(!toggleAllSections)}
      >
        MySQL Database Fundamentals
      </div>

      {toggleAllSections && (
        <div className="list-tab mt-3">
          {listContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id)}
              >
                {title}
                <span>{sectionToggle[id] ? "-" : "+"}</span>
              </div>
              {sectionToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Spring Boot Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleNewModule(!toggleNewModule)}
      >
        Spring Boot Fundamentals
      </div>

      {toggleNewModule && (
        <div className="list-tab mt-3">
          {newModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "new")}
              >
                {title}
                <span>{newModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {newModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* MySQL & Spring Boot Integration Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExteraModule(!toggleExteraModule)}
      >
        MySQL & Spring Boot Integration
      </div>

      {toggleExteraModule && (
        <div className="list-tab mt-3">
          {exteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extera")}
              >
                {title}
                <span>{exteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {exteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Spring Boot Security Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleAdditionalModule)}
      >
        Spring Boot Security & Advanced Features
      </div>

      {toggleAdditionalModule && (
        <div className="list-tab mt-3">
          {additionalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{additionalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {additionalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Advanced Database Concepts Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleIsExteraModule(!toggleIsExteraModule)}
      >
        Advanced Database Concepts & Optimization
      </div>

      {toggleIsExteraModule && (
        <div className="list-tab mt-3">
          {isExteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "isextera")}
              >
                {title}
                <span>{isExteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {isExteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
      {/* Microservices Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExtraAdvancedModule(!toggleExtraAdvancedModule)}
      >
        Microservices with Spring Boot & Spring Cloud
      </div>

      {toggleExtraAdvancedModule && (
        <div className="list-tab mt-3">
          {extraAdvancedModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extraAdvanced")}
              >
                {title}
                <span>{extraAdvancedModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {extraAdvancedModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
      {/* Testing and Deployment Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAndLocalModule(!toggleAndLocalModule)}
      >
        Testing, Deployment & DevOps
      </div>

      {toggleAndLocalModule && (
        <div className="list-tab mt-3">
          {andLocalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "andLocal")}
              >
                {title}
                <span>{AndLocalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {AndLocalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
      {/* Capstone Project Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAndUlteraLocalModule(!toggleAndUlteraLocalModule)}
      >
        Capstone Project: Full-Stack Application Development
      </div>

      {toggleAndUlteraLocalModule && (
        <div className="list-tab mt-3">
          {andUlteraLocalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "andUlteraLocal")}
              >
                {title}
                <span>{AndUlteraLocalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {AndUlteraLocalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LearningPathTFD;